import { userReducer } from '@sde/widgets-core/src/redux/resources/user';
import { onboardingReducer } from '@sde/widgets-core/src/redux/resources/onboarding';
// import { ticketDetailsReducer } from '@sde/widgets-trackit/src/redux/resources/ticketDetails';
// import { smartEditsReducer } from '@sde/widgets-trackit/src/redux/resources/smartEdits';
// import { trackitEmailReducer } from '@sde/widgets-trackit/src/redux/resources/trackitEmail';
// import { pharmaCouponTicketsReducer } from '@sde/widgets-claims/src/redux/resources/pharmaCoupon';
import { payersReducer } from '@sde/widgets-core/src/redux/resources/payers';
import { tabsReducer } from '@sde/widgets-core/src/redux/resources/tabs';
// import { reportHubReducer } from '@sde/widgets-report-hub/src/redux/resources/reportHubState';
import { printingReducer } from './printing';
import { dashboardReducer } from './dashboard/reducer';
import { payerReducer } from './payer/reducer';
import { providerReducer } from './provider/reducer';
import { headerMenuReducer } from './headerMenu/reducer';
import { modalReducer } from './modal/reducer';
import { alertsReducer } from './alerts/reducer';
import { breadcrumbsReducer } from './breadcrumbs';
import { searchResultReducer } from './searchResults';
import { tutorialReducer } from './tutorial';
import { actionRequiredFilterReducer } from './actionRequiredFilter';

export const reducers = {
  actionRequiredFilter: actionRequiredFilterReducer,
  user: userReducer,
  dashboard: dashboardReducer,
  payer: payerReducer,
  provider: providerReducer,
  // ticketDetails: ticketDetailsReducer,
  // smartEdits: smartEditsReducer,
  headerMenu: headerMenuReducer,
  modal: modalReducer,
  alerts: alertsReducer,
  breadcrumbs: breadcrumbsReducer,
  multiMemberSearch: searchResultReducer,
  onboarding: onboardingReducer,
  tutorial: tutorialReducer,
  printing: printingReducer,
  // trackitEmail: trackitEmailReducer,
  // pharmaCoupons: pharmaCouponTicketsReducer,
  payers: payersReducer,
  tabs: tabsReducer,
  // reportHub: reportHubReducer,
};
